// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@6.10.0_webpack@5.82.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../common/temp/node_modules/.pnpm/css-loader@6.10.0_webpack@5.82.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":host{display:block;width:100%;height:100%;min-width:100%;min-height:100%}.ugc-app-frame{width:100%;height:100%;border-style:none;vertical-align:middle;max-width:100%}slot[name=size-chart]::slotted(*){width:90vw}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
